/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrganizationKeysAndNames } from '../../models/organization-keys-and-names';

export interface GetPlatformOrganizations$Params {
}

export function getPlatformOrganizations(http: HttpClient, rootUrl: string, params?: GetPlatformOrganizations$Params, context?: HttpContext): Observable<StrictHttpResponse<OrganizationKeysAndNames>> {
  const rb = new RequestBuilder(rootUrl, getPlatformOrganizations.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OrganizationKeysAndNames>;
    })
  );
}

getPlatformOrganizations.PATH = '/platform/organizations';
